// extracted by mini-css-extract-plugin
export var active = "_e1-7";
export var blink = "_e1-8";
export var dropDownSelector = "_e1-4";
export var dropDownWrapper = "_e1-3";
export var fakeCursor = "_e1-6";
export var fontSizeButton = "_e1-9";
export var formQuillEditor = "_e1-0";
export var pressed = "_e1-a";
export var qlBlank = "_e1-1";
export var textFormattingToolbar = "_e1-2";
export var textToolbarOption = "_e1-5";